import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { ApiService } from '../services/api.service';
import { Store } from '../store';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Label } from './model/label';
import { ELabelType, ILabel } from '../models/label';

@Injectable({
    providedIn: 'root',
})
export class LabelService {
    env = environment;

    constructor(private apiService: ApiService, private store: Store, private http: HttpClient) {}

    findAllLabels(type: string = `order_board`) {
        return this.http.get(this.env.apiPath + `labels/type/${type}`, this.apiService.getHttpOptions()).pipe(
            map((data: any) => data.data),
            catchError(this.apiService.handleError)
        );
    }

    findAllLabelsForOrderId(id: string) {
        return this.http
            .get(this.env.apiPath + `labels/assigned/order_board/${id}`, this.apiService.getHttpOptions())
            .pipe(
                map((data: any) => data.data),
                catchError(this.apiService.handleError)
            );
    }

    createLabel(label: ILabel) {
        const user = this.store.selectForLocal('user');
        const dataToSend = {
            name: label.name,
            type: label.type ?? 'order_board',
            colour: label.colour,
            createdBy: user.id,
        };
        return this.http.post(this.env.apiPath + 'labels', dataToSend, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data.data;
            }, catchError(this.apiService.handleError))
        );
    }

    editLabel(label: ILabel) {
        const user = this.store.selectForLocal('user');
        const dataToSend = {
            name: label.name,
            type: label.type ?? 'order_board',
            id: label.id,
            colour: label.colour,
            createdBy: user.id,
        };
        return this.http.put(this.env.apiPath + 'labels', dataToSend, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data;
            }, catchError(this.apiService.handleError))
        );
    }

    assignLabel(labelId: string, entityId: string, type = ELabelType.OrderBoard) {
        const dataToSend = {
            label: {
                id: labelId,
                type: type,
            },
            recordId: entityId,
        };
        return this.http.post(this.env.apiPath + 'labels/assign', dataToSend, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data.data;
            }, catchError(this.apiService.handleError))
        );
    }

    unassignLabel(labelId: string, orderId: string) {
        const dataToSend = {
            label: {
                id: labelId,
                type: 'order_board',
            },
            recordId: orderId,
        };
        return this.http.post(this.env.apiPath + 'labels/unassign', dataToSend, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data.data;
            }, catchError(this.apiService.handleError))
        );
    }
}
